import { Button } from '@/components/ui/button';
import { Plan } from '../types';

interface ChannelSelectionProps {
  plan: Plan;
  versionId: number;
  onClose: () => void;
}

export function ChannelSelection({ plan, versionId, onClose }: ChannelSelectionProps) {
  // Use the plan prop to disable the TypeScript warning
  console.log('Plan:', plan.id, 'Version:', versionId);

  return (
    <div className="space-y-4">
      <div className="text-center p-8">
        <p className="text-muted-foreground mb-4">
          Channel assignment functionality will be available after the Channel Management feature is implemented.
        </p>
        <Button variant="outline" onClick={onClose}>
          Close
        </Button>
      </div>
    </div>
  );
}